var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"inicio"}},[_c('MenuBar'),_c('router-view'),_c('pie-pagina-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }